import { create } from 'zustand';

export const useUploadBusyStore = create((set, get) => ({
  count: 0,
  start: () => set({ count: get().count + 1 }),
  stop: () => set({ count: Math.max(0, get().count - 1) }),
}));
